<div>
  <full-calendar #calendar
    [header]="calendarHeader"
    [customButtons]="calendarButtons"
    defaultView="dayGridMonth"
    [plugins]="calendarPlugins"
    [firstDay]="1"
    [weekends]="true"
    [contentHeight]="600"
    [displayEventTime]="false"
    [events]="events"
    [eventLimit]="true"
    [views]="views"
    (eventClick)="onEventClick($event)"></full-calendar>
</div>